// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.overall-pr {
  background-color: var(--rCBlue);
  border: none;
  border-radius: 30px;
}

.total-rating h2 {
  color: var(--blue);
  font-size: 90px;
  font-weight: 700;
  padding: 70px 0px 0px 0px;
  margin-bottom: 0px;
  line-height: 1;
}

.result-rating-card {
  padding-top: 0px;
}

.star-rating {
  padding-bottom: 10px;
}

.star-rating .star {
  font-size: 30px;
}

.no-reviews-text {
  padding: 10px;
  text-align: center;
  background: var(--dPink);
  color: #fff;
  font-weight: 500;
  margin-top: -30px;
}

@media (max-width: 767px) {
  .rating-percent {
    padding: 40px 20px !important;
    margin-top: 10%;
  }

  .progress-bar-percent {
    column-gap: 10px !important;
  }

  .star-count .star {
    font-size: 14px;
  }
}

.pr-card-text p {
  color: var(--black);
  font-size: 20px;
}

.rating-percent {
  background-color: var(--rCBlue);
  padding: 45px 40px;
  border-radius: 30px;
}

.rating-percent .progress {
  margin: 15px 0px;
  --bs-progress-bar-bg: var(--blue) !important;
  --bs-progress-bg: #e9ecef;
  height: 0.5rem;
  width: 80%;
}

.progress-bar-percent {
  display: flex;
  align-items: center;
  column-gap: 60px;
  padding-left: 10px;
}

.rating-percent .star-count {
  width: 15%;
  text-align: center;
}

.progress-bar-percent .star-percent {
  width: 10%;
  text-align: right;
}

.star-count .star {
  font-size: 22px;
}

.grey-star {
  color: var(--grey);
  font-size: 20px;
}

.star-percent {
  margin-bottom: 0px;
}

.view-all-review-btn a {
  color: var(--cSPink);
  text-decoration: underline;
}
`, "",{"version":3,"sources":["webpack://./src/component/common/product-rating/ProductRating.css"],"names":[],"mappings":"AAAA;EACE,+BAA+B;EAC/B,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,wBAAwB;EACxB,WAAW;EACX,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE;IACE,6BAA6B;IAC7B,eAAe;EACjB;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,+BAA+B;EAC/B,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,4CAA4C;EAC5C,yBAAyB;EACzB,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,0BAA0B;AAC5B","sourcesContent":[".overall-pr {\n  background-color: var(--rCBlue);\n  border: none;\n  border-radius: 30px;\n}\n\n.total-rating h2 {\n  color: var(--blue);\n  font-size: 90px;\n  font-weight: 700;\n  padding: 70px 0px 0px 0px;\n  margin-bottom: 0px;\n  line-height: 1;\n}\n\n.result-rating-card {\n  padding-top: 0px;\n}\n\n.star-rating {\n  padding-bottom: 10px;\n}\n\n.star-rating .star {\n  font-size: 30px;\n}\n\n.no-reviews-text {\n  padding: 10px;\n  text-align: center;\n  background: var(--dPink);\n  color: #fff;\n  font-weight: 500;\n  margin-top: -30px;\n}\n\n@media (max-width: 767px) {\n  .rating-percent {\n    padding: 40px 20px !important;\n    margin-top: 10%;\n  }\n\n  .progress-bar-percent {\n    column-gap: 10px !important;\n  }\n\n  .star-count .star {\n    font-size: 14px;\n  }\n}\n\n.pr-card-text p {\n  color: var(--black);\n  font-size: 20px;\n}\n\n.rating-percent {\n  background-color: var(--rCBlue);\n  padding: 45px 40px;\n  border-radius: 30px;\n}\n\n.rating-percent .progress {\n  margin: 15px 0px;\n  --bs-progress-bar-bg: var(--blue) !important;\n  --bs-progress-bg: #e9ecef;\n  height: 0.5rem;\n  width: 80%;\n}\n\n.progress-bar-percent {\n  display: flex;\n  align-items: center;\n  column-gap: 60px;\n  padding-left: 10px;\n}\n\n.rating-percent .star-count {\n  width: 15%;\n  text-align: center;\n}\n\n.progress-bar-percent .star-percent {\n  width: 10%;\n  text-align: right;\n}\n\n.star-count .star {\n  font-size: 22px;\n}\n\n.grey-star {\n  color: var(--grey);\n  font-size: 20px;\n}\n\n.star-percent {\n  margin-bottom: 0px;\n}\n\n.view-all-review-btn a {\n  color: var(--cSPink);\n  text-decoration: underline;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
